import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducer/reducer";
import { composeWithDevTools } from "redux-devtools-extension";

const Production = process.env.REACT_APP_PRODUCTION === "true" ? true : false;
const showRedux = !Production
    ? composeWithDevTools(applyMiddleware(thunk))
    : applyMiddleware(thunk);
const store = createStore(reducer, showRedux);

export default store;
